'use client';

import logo from '@/assets/logo.png';
import { navlinkData, navlinkMobileData } from '@/constant/index';
import { baseStaticURL } from '@/lib/servies/axiosConfig';
import { cn } from '@/lib/utils';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import MenuMobile from '../common/MenuMobile';
import { SheetClose } from '../ui/sheet';
import BtnLogin from './BtnLogin';
import CityModal from './city-modal';

export default function Navlink() {
    const pathName = usePathname();

    const { data: cities } = useQuery({
        queryKey: ['nav-cities'],

        queryFn: async () => {
            try {
                const url = `${baseStaticURL}/city_new`;

                const response = await axios.get(url);
                return response.data.result;
            } catch {
                throw new Error('Error fetching data');
            }
        },
        staleTime: 1000 * 60 * 60 * 24,
        gcTime: 1000 * 60 * 60 * 24,
    });

    return (
        <div className="lg:container flex flex-col mx-auto">
            <nav className="flex justify-between shadow-md lg:justify-start xs:!pr-2 !px-2 smp:!pl-4 py-2 gap-1 rounded-b-2xl lg:rounded-2xl lg:gap-2 xl:gap-4 items-center bg-[#fff] h-[64px] lg:h-[84px] md:!pe-6">
                <div className="lg:hidden flex size-fit items-center">
                    <MenuMobile>
                        <ul className="grid gap-2 mt-5 text-center font-medium">
                            {navlinkMobileData.map((i) => (
                                <Link key={i.id} href={i.link}>
                                    <SheetClose asChild>
                                        <li
                                            className={cn(
                                                'p-2 w-full flex items-center justify-between text-[17px] rounded-l-2xl text-[#222222]',
                                                pathName === i.link &&
                                                    'bg-blue-shaded border-r-4 border-blue text-black',
                                            )}
                                        >
                                            {i.label}
                                        </li>
                                    </SheetClose>
                                </Link>
                            ))}
                        </ul>
                    </MenuMobile>
                </div>
                <div className="w-full flex justify-between gap-1 xl:gap-8">
                    <Link href={'/'} className="xl:ml-0 ml-3">
                        <Image
                            src={logo}
                            alt="درمان شیرین"
                            width={135}
                            height={48}
                            fetchPriority="high"
                            loading="eager"
                            className="h-[48px] xl:!min-w-[135px] xl:!max-w-[135px] lg:min-w-[115px] lg:!max-w-[115px] sm:!min-w-[125px] sm:!max-w-[125px] min-w-[115px] max-w-[115px]  object-contain lg:!mr-0 mr-2 !block "
                        />
                    </Link>
                    <ul className="items-center gap-4 xl:gap-7 hidden lg:flex flex-grow text-nowrap">
                        {navlinkData.map((items) =>
                            items.link === pathName ? (
                                <li
                                    key={items.id}
                                    className={`text-base -translate-y-0.5 text-blue font-bold font_head cursor-pointer`}
                                    onClick={() => {
                                        window.location.replace(items.link);
                                    }}
                                >
                                    {items.label}
                                </li>
                            ) : (
                                <li
                                    key={items.id}
                                    className={`text-sm text-[#222222] hover:text-blue transition-transform hover:-translate-y-0.5 font-bold font_head`}
                                >
                                    <Link prefetch={false} href={items.link}>
                                        {items.label}
                                    </Link>
                                </li>
                            ),
                        )}
                    </ul>

                    <div className="flex items-center">
                        <CityModal data={cities} />
                        <BtnLogin />
                    </div>
                </div>
            </nav>
        </div>
    );
}
